import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ResetPasswordPage from "@/pages/ResetPassword";
import AnalyticsPage from "@/pages/Analytics";
import DashboardPage from "@/pages/Dashboard";
import ClientsPage from "@/pages/Clients";
import ClientDashboardPage from "@/pages/ClientDashboard";
import JobsPage from "@/pages/Jobs";
import JobDetailPage from "@/pages/JobDetail";
import CandidatePage from "@/pages/Candidate";
import CandidatesPage from "@/pages/Candidates";
import SettingsPage from "@/pages/Settings";
import RecyclePage from "@/pages/Recycle";
import WorkspacesPage from "@/pages/Workspaces";
import LicensesPage from "@/pages/Licenses";
import TeamJoinPage from "@/pages/TeamJoin";
import LandingPage from "@/pages/Landing";
import PricingPage from "@/pages/public/Pricing";
import AboutPage from "@/pages/public/About";
import LegalPage from "@/pages/public/Legal";
import ComingSoonPage from "@/pages/public/ComingSoon";
import InvitePage from "@/pages/candidate/Invite";
import VoiceRoom from "@/pages/candidate/VoiceRoom";
import VideoRoom from "@/pages/candidate/VideoRoom";
import CodingRoom from "@/pages/candidate/CodingRoom";
import DoneRoom from "@/pages/candidate/Done";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-500 bg-white">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppToaster() {
  const { pathname } = useLocation();
  return <Toaster theme="system" position={/\/invite\/[^/]+\/coding/.test(pathname) ? "bottom-left" : "top-right"} richColors closeButton />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppToaster />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/legal/:doc" element={<LegalPage />} />
          <Route path="/careers" element={<ComingSoonPage />} />
          <Route path="/blog" element={<ComingSoonPage />} />
          <Route path="/press" element={<ComingSoonPage />} />
          <Route path="/docs" element={<ComingSoonPage />} />
          <Route path="/docs/api" element={<ComingSoonPage />} />
          <Route path="/help" element={<ComingSoonPage />} />
          <Route path="/status" element={<ComingSoonPage />} />
          <Route path="/integrations" element={<ComingSoonPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          <Route path="/app" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/app/jobs" element={<Protected><JobsPage /></Protected>} />
          <Route path="/app/clients" element={<Protected><ClientsPage /></Protected>} />
          <Route path="/app/clients/:clientId" element={<Protected><ClientDashboardPage /></Protected>} />
          <Route path="/app/jobs/:jobId" element={<Protected><JobDetailPage /></Protected>} />
          <Route path="/app/candidates" element={<Protected><CandidatesPage /></Protected>} />
          <Route path="/app/candidates/:candId" element={<Protected><CandidatePage /></Protected>} />
          <Route path="/app/settings" element={<Protected><SettingsPage /></Protected>} />
          <Route path="/app/recycle" element={<Protected><RecyclePage /></Protected>} />
          <Route path="/app/workspaces" element={<Protected><WorkspacesPage /></Protected>} />
          <Route path="/app/licenses" element={<Protected><LicensesPage /></Protected>} />
          <Route path="/app/analytics" element={<Protected><AnalyticsPage /></Protected>} />
          <Route path="/team-invite/:token" element={<TeamJoinPage />} />

          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/invite/:token/voice" element={<VoiceRoom />} />
          <Route path="/invite/:token/video" element={<VideoRoom />} />
          <Route path="/invite/:token/coding" element={<CodingRoom />} />
          <Route path="/invite/:token/done" element={<DoneRoom />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
